// extracted by mini-css-extract-plugin
export default {"editMenu":"EditMenu_editMenu__ElL76","listItem":"EditMenu_listItem__yE9QG","link":"EditMenu_link__ewgJk"};